'use strict';

var processInclude = require('base/util');
processInclude(require('../product/pdpInstoreInventory'));

/**
 * Listen for shipping method changes
 */
function setShippingMethodSelection() {
    $('body').on('setShippingMethodSelection', function (e, basket) {
        if (basket.disableShippingMethod === '') {
            $('#shippingMethods').removeAttr('disabled');
        }
    });
}

module.exports = {
    init: function () {
        setShippingMethodSelection();
    }
};
